// Types
import Vue from"vue";const SocialLoginView=Vue.extend({name:"SocialLoginView",render(){const a=arguments[0];return a("div",["Social Login"])}});export default SocialLoginView;